// extracted by mini-css-extract-plugin
export var rtf = "A7mmV";
export var title = "-vKXn";